import { useState } from 'react';
import api from '../api/axios';
import { Link } from 'react-router-dom';
import { Mail, Lock, ArrowRight, ShieldCheck, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [correo, setCorreo] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/login', { correo, password });
      
      // Usa el contexto para hacer login
      login(res.data.user, res.data.token);
      
      // Opción 1: Recarga completa forzada
      window.location.href = '/propiedades';
      
      // O Opción 2: Navegar y luego recargar
      // navigate('/propiedades');
      // setTimeout(() => window.location.reload(), 100);
      
    } catch (err) {
      setError(err.response?.data?.error || 'Credenciales inválidas. Por favor intente de nuevo.');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      {/* Columna Izquierda: Imagen Estética */}
      <div className="hidden lg:block relative overflow-hidden bg-slate-900">
        <img 
          src="https://images.unsplash.com/photo-1600566752355-35792bedcfea?auto=format&fit=crop&q=80&w=2000" 
          alt="Luxury Architecture" 
          className="absolute inset-0 w-full h-full object-cover opacity-60 mix-blend-overlay"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />
        <div className="absolute bottom-16 left-16 right-16">
          <span className="text-blue-400 text-xs font-bold uppercase tracking-[0.4em] mb-4 block">VEstates Global</span>
          <h2 className="text-4xl font-serif italic text-white leading-tight">
            "La arquitectura es el testigo menos sobornable de la historia."
          </h2>
          <div className="mt-8 flex items-center gap-4 text-slate-400">
             <div className="h-[1px] w-12 bg-slate-600" />
             <span className="text-[10px] uppercase tracking-widest">Octavio Paz</span>
          </div>
        </div>
      </div>

      {/* Columna Derecha: Formulario */}
      <div className="flex items-center justify-center p-8 md:p-16 bg-white">
        <div className="w-full max-w-sm space-y-12">
          {/* Logo / Header */}
          <div className="text-center lg:text-left space-y-4">
            <Link to="/" className="inline-block">
                <span className="text-3xl font-serif italic text-slate-900 tracking-tighter">
                  V<span className="font-sans not-italic font-light tracking-widest uppercase text-xs ml-1 border-l border-slate-900 pl-2">Estates</span>
                </span>
            </Link>
            <h1 className="text-2xl font-light text-slate-500">Acceso al Portal</h1>
          </div>

          {error && (
            <div className="p-4 bg-red-50 border border-red-100 rounded-2xl flex items-center gap-3 text-red-600 text-sm animate-in fade-in slide-in-from-top-2">
              <AlertCircle size={18} strokeWidth={2.5} />
              <p className="font-medium">{error}</p>
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400 flex items-center gap-2">
                <Mail size={12} /> Email
              </label>
              <input
                type="email"
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                placeholder="nombre@ejemplo.com"
                className="w-full bg-slate-50 border border-slate-200 rounded-2xl px-5 py-4 text-sm focus:bg-white focus:ring-4 focus:ring-blue-500/5 focus:border-blue-500 transition-all outline-none text-slate-700 placeholder:text-slate-300"
                required
              />
            </div>

            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400 flex items-center gap-2">
                  <Lock size={12} /> Contraseña
                </label>
                <button type="button" className="text-[10px] font-bold text-blue-600 hover:text-slate-900 transition-colors uppercase tracking-widest">
                  ¿Olvidó su contraseña?
                </button>
              </div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full bg-slate-50 border border-slate-200 rounded-2xl px-5 py-4 text-sm focus:bg-white focus:ring-4 focus:ring-blue-500/5 focus:border-blue-500 transition-all outline-none text-slate-700 placeholder:text-slate-300"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="group relative w-full bg-slate-900 text-white py-5 rounded-2xl font-bold uppercase tracking-[0.3em] text-[10px] hover:bg-blue-700 transition-all shadow-xl shadow-slate-900/10 disabled:bg-slate-300 flex items-center justify-center gap-3"
            >
              {loading ? (
                <div className="w-4 h-4 border-2 border-white/30 border-t-white animate-spin rounded-full" />
              ) : (
                <>
                  Entrar al Catálogo
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </>
              )}
            </button>
          </form>

          {/* Footer Social/Info */}
          <footer className="pt-12 flex flex-col items-center lg:items-start gap-4 text-slate-400">
             <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest border border-slate-100 px-4 py-2 rounded-full">
                <ShieldCheck size={14} className="text-blue-500" /> Servidor Seguro VEstates
             </div>
             <p className="text-[10px] text-slate-300 uppercase tracking-tighter">© 2026 Inmobiliaria Yucatán S.A. de C.V.</p>
          </footer>
        </div>
      </div>
    </div>
  );
}
